// External libraries
import { css } from '@emotion/core';

// Internal modules
import { FLAGS_SPRITE_URL } from '@/styles';

const getDropdownContainerStyleOverrides = flagPos => css`
  background-image: url(${FLAGS_SPRITE_URL});
  background-position: 8px ${flagPos}px;
  background-repeat: no-repeat;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 0;

  /* Down caret */
  &::before {
    right: 10px;
  }

  @media (max-width: 390px) {
    background-position: 18px ${flagPos}px;
  }
`;

const dialingCodeStyles = css`
  > div {
    /* <PhoneType /> container */
    &:first-of-type {
      @media (max-width: 390px) {
        display: block;
        margin-bottom: 12px;
        width: auto;
      }
    }

    /* <PhoneInput /> container */
    &:last-of-type {
      @media (min-width: 391px) {
        width: calc(100% - 190px);
      }
    }

    /* <DialingCode /> container */
    &:nth-of-type(2) {
      width: 80px;

      @media (min-width: 391px) {
        margin-left: 10px;
        width: 60px;
      }
    }
  }
`;

const dropdownLabelStyleOverrides = css`
  opacity: 0;
`;

const phoneInputStyleOverrides = {
  containerStyleOverrides: css`
    margin-bottom: 0;
  `,
  inputStyleOverrides: css`
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  `,
};

const phoneTypeStyleOverrides = css`
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`;

const phoneTypeStyleOverridesDialingCodeChange = css`
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
`;

export {
  dialingCodeStyles,
  dropdownLabelStyleOverrides,
  getDropdownContainerStyleOverrides,
  phoneInputStyleOverrides,
  phoneTypeStyleOverrides,
  phoneTypeStyleOverridesDialingCodeChange,
};
